//********* TUTORIALS *********//
import * as types from "./actionTypes";

export const showMaterialsTutorial = (materialsTutorialIsOpened) => ({
  type: types.SHOW_MATERIALS_TUTORIAL,
  payload: {materialsTutorialIsOpened}
});

export const setMaterialsTutorialStep = (materialsTutorialStep) => ({
  type: types.SET_MATERIALS_TUTORIAL_STEP,
  payload: {materialsTutorialStep}
});

export const setMaterialsTutorialFinished = (materialsTutorialFinished) => ({
  type: types.SET_MATERIALS_TUTORIAL_FINISHED,
  payload: {materialsTutorialFinished}
});

export const showMaterialsAgentTutorial = (materialsAgentTutorialIsOpened) => ({
  type: types.SHOW_MATERIALS_AGENT_TUTORIAL,
  payload: {materialsAgentTutorialIsOpened}
});

export const setMaterialsAgentTutorialFinished = (materialsAgentTutorialFinished) => ({
  type: types.SET_MATERIALS_AGENT_TUTORIAL_FINISHED,
  payload: {materialsAgentTutorialFinished}
});

export const showVisualizerTutorial = (visualizerTutorialIsOpened) => ({
  type: types.SHOW_VISUALIZER_TUTORIAL,
  payload: {visualizerTutorialIsOpened}
});

export const setVisualizerTutorialStep = (visualizerTutorialStep) => ({
  type: types.SET_VISUALIZER_TUTORIAL_STEP,
  payload: {visualizerTutorialStep}
});

export const setVisualizerTutorialFinished = (visualizerTutorialFinished) => ({
  type: types.SET_VISUALIZER_TUTORIAL_FINISHED,
  payload: {visualizerTutorialFinished}
});
